import { Component, OnInit, ViewEncapsulation, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIService } from '@app/cp/shared/services/DQOI.service';
import { v_DispatchSearchBus } from '@app/cp/shared/models/v_DispatchSearchBus';
import { AutoCompleteComponent, ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { DQOISearchParam } from '@app/cp/shared/models/DQOISearchParam';
import { SearchTarget } from '@app/cp/shared/enums/SearchTarget';
import { ControlType } from '@app/cp/shared/enums/ControlTypes';
import { GItem } from '@app/cp/shared/models/GItem';
import { BaseGridComponent } from '@app/cp/shared/base-components/base-grid.component';
import { v_DispatchGrid2Bus } from '@app/cp/shared/models/v_DispatchGrid2Bus';
import { DispatchSearch } from '@app/cp/shared/DispatchSearch';
import { DispatchSearchType } from '@app/cp/shared/enums/dispatchSearchType';
import { DQOISearchEvent } from '@app/cp/shared/models/DQOISearchEvent';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { SelectionEvent } from '@progress/kendo-angular-grid';

@Component({
    selector: 'detail-search',
    templateUrl: './detail-search.component.html',
    styleUrls: ['./detail-search.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DetailSearchComponent extends BaseGridComponent<any, null> {

    SearchTarget: SearchTarget;
    svc_data: DQOIService;
    @Input() minSearchSize: number = 3;
    @Input() searchTarget: SearchTarget = SearchTarget.dispatch;
    @Input() serviceMode: string;
    customerId: any;
    locationId: any;
    search_note: string;
    isActive: boolean = true;
    selected_type: GItem;
    default_type: GItem = { "description": "All Dispatches & Jobs", "value": "A", "category": "", "reference": null };
//    selected_option: GItem;
    selected_option: String = 'D';
    default_option: GItem; // = this.svc_data.searchOptions[0]; // { "description": "Note Text", "value": "N", "category": "" };
    //searchType: DispatchSearchType = DispatchSearchType.all;
    public startDate: Date = null;
    public endDate: Date = null; // = new Date(Date.now());
    constructor(globals: GlobalsService, featureFlagService: FeatureFlagService, svc_data: DQOIService) {
        super(globals, featureFlagService);
        this.svc_data = svc_data;
        this.default_option = this.svc_data.searchOptions[0];
    }

    customerChanged(e: any) {
        this.customerId = e;
    }
    locationChanged(e: any) {
        this.locationId = e;
    }
    searchGrid() {
        this.data = null;
        this.gridData = null;
        this.skip = 0;
        this.getData();
    }
    getData() {
        this.dataLoading = true;
        let search: DispatchSearch = new DispatchSearch();
        let searchParam: DQOISearchParam = new DQOISearchParam();
        searchParam.userId = this.globals.userId;
        searchParam.customerId = this.customerId;
        searchParam.locationId = this.locationId; // (this.selected_location !== undefined && this.selected_location !== null) ? this.selected_location.value : "";
        searchParam.isOpen = this.isActive;
        searchParam.search = this.search_note;
        searchParam.startDate = this.startDate;
        searchParam.endDate = this.endDate;
        searchParam.searchTarget = this.searchTarget;
        if (this.subs_data !== undefined && this.subs_data !== null) {
            this.subs_data.unsubscribe();
        }
        this.subs_data = this.svc_data.dqoiSearch(searchParam).subscribe(data => {
            this.data = data;
            this.gridData = data;
            this.dataLoading = false;;

        })

    }

    clear() {

    }
    onStartDateChange(e: any) {
        this.startDate = e;
    }
    onEndDateChange(e: any) {
        this.endDate = e;
    }
    openChanged(e: any) {
        this.isActive = e;
    }
    allChanged(e: any) {
    }
    selected(e: any) {
        let se: DQOISearchEvent = new DQOISearchEvent();
        se.searchTarget = this.searchTarget;
        switch (this.searchTarget) {
            case SearchTarget.dispatch:
                se.dispatchId = e.dispatchId;
                break;
            case SearchTarget.invoice:
                se.invoiceNumber = e.invoiceNumber;
                break;
            case SearchTarget.quote:
                se.quoteNumber = e.quoteNumber;
                break;
            case SearchTarget.order:
                //se.orderNumber = e.orderNumber;
                break;
        }
        //se.invoiceNumber = e
        this.svc_data.nextSearchEvent(se);
    }
    typeCBOChanged(e: any) {

    }
}
